import { SITE_CONFIG } from '../../../config/site-config';
import { toReadableFields } from '../field-labels';
import type { FormPayload } from './delivery-types';

const fallbackAddress = (): string => SITE_CONFIG.FORM_EMAIL || SITE_CONFIG.SALES_EMAIL;

/** A `mailto:` link that opens the visitor's email app with the submission pre-filled. */
export function buildFallbackMailto(payload: FormPayload, formType: string): string {
  const body = Object.entries(toReadableFields(payload))
    .map(([label, value]) => `${label}: ${value}`)
    .join('\n');
  return `mailto:${fallbackAddress()}?subject=${encodeURIComponent(`[ReTax360] ${formType}`)}&body=${encodeURIComponent(body)}`;
}

export function openEmailFallback(payload: FormPayload, formType: string): void {
  window.location.href = buildFallbackMailto(payload, formType);
}
